module.exports = __webpack_public_path__ + "img/undraw_Web_search.a8221ec5.svg";